import React, { memo } from 'react';
import { ExclamationCircleIcon, ExclamationTriangleIcon } from '@patternfly/react-icons'
import { Badge } from '@patternfly/react-core';

import './customization-page.css';
import { ValidationStatus } from '../../store/global-types/customization-types';

interface SectionLabelProps {
    validationStatus?: ValidationStatus,
    isModified: boolean,
    badge?: string | number,
    label: string,
}

const SectionLabel = (props: SectionLabelProps) => {
    const { validationStatus = ValidationStatus.Valid, isModified, badge, label } = props;
    const cssClass = validationStatus === ValidationStatus.Error ? 'validation-error'
        : validationStatus === ValidationStatus.Warning ? 'validation-warning'
        : '';
    return (
        <span className={`customization-section-header ${cssClass}`}>
            <span>
                {validationStatus === ValidationStatus.Error && <span className="validation-icon"><ExclamationCircleIcon /></span>}
                {validationStatus === ValidationStatus.Warning && <span className="validation-icon"><ExclamationTriangleIcon /></span>}
                <span className="header-title">{label}</span>
                {isModified && <span className="modified"> *</span>}
            </span>
            {badge !== undefined && (<span className="badge"><Badge isRead>{badge}</Badge></span>)}
        </span>
    )
}

export default memo(SectionLabel);
